module.exports = __webpack_public_path__ + "static/img/home-hero-tablet-bg.a79a022.png";